<template>
    <div class="function-item" @click="expandDetailFunction(func)">
        <div class="function-details">
            <div class="icon-desc-container">
                <v-icon class="mr-2"
                :class="['chevron-icon', { 'rotate-up': func.show_detail }]" style="margin-bottom: 16px;">mdi-chevron-down</v-icon>
                <div class="name-desc">
                    <h3>{{ func.name }}</h3>
                    <p class="short-desc">{{ func.short_desc }}</p>
                </div>
            </div>
            <div class="icon-desc-container">
              <p class="last-updated">{{ this.$f.tc('lastUpdated') }} : {{ displayTime(func.updated_time, 'HH:mm DD-MM-YYYY') }}</p>
            </div>
        </div>

    </div>
</template>
<script>
import moment from 'moment'

export default {
    name: 'FunctionItem',
    props: {
        func: {
            type: Object,
            required: true
        }
    },
    methods: {
        displayTime (value, format) {
            if (!format) {
                format = 'YYYY-MM-DD HH:mm:ss'
            }
            try {
                let ct = moment.utc(value).local()
                return ct.format(format)
            } catch (e) {
                return value
            }
        },
        expandDetailFunction (func) {
            if (func.show_detail === true) {
                func.show_detail = false
                setTimeout(function () { func.load_detail = false }, 500)
            } else {
                func.show_detail = true
                func.load_detail = true
            }
            this.$emit('functionSelected', func.id)
        }
    }
}
</script>
<style>
.function-item {
  margin-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
}

.function-details {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Vertically align items in the center */
}
.function-details p {
  color: #757575;
}
.icon-desc-container {
  display: flex;
  align-items: center;
}

.name-desc {
  display: flex;
  flex-direction: column;
}

.short-desc {
  margin: 0;
}

.last-updated {
  margin: 0;
  text-align: right;
}

.rotate-up {
  color: #0052CC !important;
  transform: rotateX(180deg); /* Apply the 180-degree flip effect */
}
</style>
